import React, {useEffect} from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Form } from './components';
import { Mixpanel } from '@/utils/mixpanel';
import Container from '@/src/common/Container';
import Meta  from '@/src/components/Meta';
import { useRouter } from 'next/router';
import { Faq } from '@/src/components';
import { FAQ_TYPE_CONTACT } from '@/src/components/Faq/Faq';
import { useSite } from '@/src/contexts/SiteContext';

const Contact = () => {
  const router = useRouter();
  const theme = useTheme();
  const { site } = useSite()
  
  useEffect(() => {
    if(!router.isReady) return;
    Mixpanel.track('contact page');
  });
  return (
    <Box>
      <Meta
        site={site}
        title={`${site?.storeName} | contact us`}
        description={`Contact the ${site?.storeName}  team with any question, suggestion or feedback.`}
      />

      <Container paddingBottom={'10px !important'}>
        <Box boxShadow={4} borderRadius={2}>
          <Box bgcolor={theme.palette.primary.main} borderRadius={2}>
            <Container paddingX={{ xs: 2, sm: 4, padding: '20px !important' }}>
              <Typography
                align="center"
                variant={'h4'}
                sx={{
                  fontWeight: 700,
                  color: theme.palette.common.white,
                }}
              >
                Contact us
              </Typography>
            </Container>
            <Box
              component={'svg'}
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 1920 100.1"
              width={'100%'}
              marginBottom={-1}
            >
              <path
                fill={theme.palette.background.paper}
                d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
              ></path>
            </Box>
          </Box>
          <Container
            paddingTop={'0 !important'}
            paddingBottom={'0 !important'}
            paddingX={{ xs: 2, sm: 4 }}
            position={'relative'}
            top={0}
          >
            <Form />
          </Container>
        </Box>
      </Container>

      <Box marginBottom={5}>
        <Typography color="text.secondary" align={'center'}>
          We will get back to you in 1-2 business days.
        </Typography>
      </Box>

      <Box bgcolor={theme.palette.alternate?.main}>
        <Container maxWidth={800}>
          <Faq type={FAQ_TYPE_CONTACT} />
        </Container>
      </Box>
    </Box>
  )
};

Contact.propTypes = {
};

export default Contact;
